module.exports = __webpack_public_path__ + "static/lucaplus-free-bg-180cc3a6408573b8c247cf7ed16d3ca3.png";